import {
  AgencyTaskSchema,
  CreatePostChecklistTask,
  PostAttachmentSchema,
  PostPlatformSchema,
  PostSchema,
} from '@ametista-ai/api-schema';
import { ApiResponse } from '@ametista-ai/api-schema/http/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/stores/api/apiClient';
import { postsKeys } from './keys';

export function useCreatePost() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      params: Partial<PostSchema> & {
        clientId: string;
        title: string;
        checklist?: CreatePostChecklistTask[];
      }
    ) => {
      return apiClient.post<
        ApiResponse<{
          post: PostSchema;
          postPlatforms: PostPlatformSchema[];
          postTasks: AgencyTaskSchema[];
          postAttachments: PostAttachmentSchema[];
        }>
      >('/v1/posts', params);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: postsKeys.all });
    },
  });
}
